import { Controller } from "@hotwired/stimulus"

const TOOLTIP_OFFSET = 10
const MIN_EDGE_THRESHOLD = 16

export default class TooltipController extends Controller {
  static targets = ["trigger", "contentTemplate"]

  show() {
    this.#createElement()
    this.#positionElement()
  }

  hide() {
    this.tooltipElement.remove()
  }

  #createElement() {
    this.tooltipElement =
      this.contentTemplateTarget.content.firstElementChild.cloneNode(true)
    this.#anchorElement().appendChild(this.tooltipElement)
  }

  #anchorElement() {
    const dialog = this.element.closest("dialog")
    return dialog || document.body
  }

  #positionElement() {
    const triggerRect = this.triggerTarget.getBoundingClientRect()
    const tooltipRect = this.tooltipElement.getBoundingClientRect()

    const top = triggerRect.top - tooltipRect.height - TOOLTIP_OFFSET
    const { left, arrowOffset } = this.#calculateHorizontalPosition(
      triggerRect,
      tooltipRect
    )

    this.tooltipElement.style.top = `${top}px`
    this.tooltipElement.style.left = `${left}px`

    this.#applyArrowOffset(arrowOffset)
  }

  #calculateHorizontalPosition(triggerRect, tooltipRect) {
    const initialLeft =
      triggerRect.left + (triggerRect.width - tooltipRect.width) / 2
    let left = initialLeft
    let arrowOffset = 0

    if (initialLeft < MIN_EDGE_THRESHOLD) {
      left = MIN_EDGE_THRESHOLD
      arrowOffset = initialLeft - left
    }

    return { left, arrowOffset }
  }

  #applyArrowOffset(arrowOffset) {
    const arrowContainer = this.tooltipElement.querySelector(
      "[data-tooltip-target='arrow']"
    )
    arrowContainer.style.transform = `translateX(calc(${arrowOffset}px - 0.25rem))`
  }
}
